// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3PfVM","buttons":"RemoveExpirationActionButtons_buttons__Ij52-"};